<template>
  <div class="dropdown-options" v-if="showDropdown">
    <div
      class="dropdown-options__row"
      v-for="option in options"
      :key="option.id"
      @click="() => handleSelectChange(option.id, option.value, option)"
    >
      <Button
        :buttonName="option.value"
        classes="blank"
        :dataToggle="useModalDataToggle ? 'modal' : ''"
        :onClick="() => {}"
      >
        <img :src="require(`@/assets/${option.icon}`)" v-if="option.icon" />
        &nbsp;&nbsp;
      </Button>
    </div>
  </div>
</template>
<script>
import Button from "@/components/button.vue";
export default {
  name: "DropdownOptions",
  props: {
    options: Array,
    label: String,
    onSelected: Function,
    showDropdown: Boolean,
    useModalDataToggle: Boolean,
  },
  setup(props) {
    const handleSelectChange = (id, value, options) =>
      props.onSelected(id, value, options);
    return {
      handleSelectChange,
    };
  },
  components: {
    Button,
  },
};
</script>
<style lang="scss">
.dropdown-options {
  background: #ffffff;
  box-shadow: 0px 0px 8px rgba(37, 40, 43, 0.12);
  border-radius: 3px;
  margin-top: 9px;
  position: absolute;
  z-index: 100;
  width: 100%;
  .button-comp {
    width: 100%;
  }
  .btn {
    width: 100%;
  }
  .button-comp:first-child,
  .btn:first-child {
    border-radius: 3px;
  }
  &__row:hover,
  .blank:hover {
    background: #1d222c0f;
  }
  &__row {
    display: flex;
    align-items: center;
    cursor: pointer;
    img {
      margin-right: 5px;
    }
  }
}
</style>
